exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__line___1Koia{border-top:2px solid #e5e5e5}.style__title___3Qd7K{text-align:center;display:flex;font-family:Poppins-Light;letter-spacing:2.6px;color:#333;font-size:11px;text-transform:uppercase}.style__title___3Qd7K:after,.style__title___3Qd7K:before{content:\"\";border-top:2px solid #e5e5e5;flex:1;margin:.75em 0}.style__title___3Qd7K:before{margin-right:15px}.style__title___3Qd7K:after{margin-left:15px}", ""]);

// exports
exports.locals = {
	"line": "style__line___1Koia",
	"title": "style__title___3Qd7K"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/horizontal-rule/style.css
// module id = 680
// module chunks = 0